














import Vue from "vue";
import { Component, Mixins } from "vue-property-decorator";
import PressButton from "../components/PressButton.vue";
import TagHelper from "../mixins/TagHelper";

@Component({ components: { PressButton } })
export default class Labels extends Mixins(TagHelper) {
  // computed
  get tagList() {
    return this.$store.state.tagList;
  }
  // hooks
  beforeCreate() {
    this.$store.commit("fetchTagList");
  }
}
